import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Retorna o conjunto de session_ids que possuem escalação interna em aberto
 * (status 'pending'). Usado para sinalizar no card da lista de Atendimento que
 * o chamado voltou para "Responder" mas ainda depende de um retorno interno.
 */
export function useOpenEscalationSessions() {
  const { data } = useQuery({
    queryKey: ['open-escalation-sessions'],
    queryFn: async (): Promise<string[]> => {
      const { data, error } = await supabase
        .from('session_escalations')
        .select('session_id')
        .eq('status', 'pending')
        .limit(1000);

      if (error) throw error;
      return (data || []).map((r) => r.session_id).filter(Boolean) as string[];
    },
    staleTime: 30 * 1000,
  });

  return new Set<string>(data ?? []);
}
